/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { Injectable } from '@angular/core';
import { ModalState } from './modal-state';
import { Store } from './store';

export enum SharePanelOverlays {
  MULTI_SELECT_PANEL = 'multiSelectPanelOpen',
  INVITE_MODAL = 'inviteModalOpen',
  SHARE_PANEL = 'sharePanelOpen',
}

@Injectable()
export class ShareStateStore extends Store<ModalState> {
  constructor() {
    super(new ModalState());
  }

  /**
   * Tracks whether a student has done a share event from just me in the current modal session.
   */
  hasStudentShared: boolean = false;

  showPanel(panel: SharePanelOverlays): void {
    this.setState({
      ...this.state,
      [panel]: true,
    });
  }

  hidePanel(panel: SharePanelOverlays): void {
    this.setState({
      ...this.state,
      [panel]: false,
    });
  }
}
